import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { formatDefaultLocale, type FormatLocaleDefinition } from 'd3-format';
import enGBLocale from 'd3-format/locale/en-GB.json';
import Root from 'Root';

import { getMsalInstance } from 'common/auth';

export function init() {
  const msalInstance = getMsalInstance();

  formatDefaultLocale(enGBLocale as FormatLocaleDefinition);
  const container = document.getElementById('root') as HTMLElement;
  const root = createRoot(container);

  root.render(
    <Suspense>
      <Root msalInstance={msalInstance} />
    </Suspense>,
  );
}

init();
